import { createReducer, on } from '@ngrx/store';
import { IUserProfileModel } from 'src/app/modules/user-profile/features/user-profile-page/models/user-profile.model';
import {
  FinishChangePassword,
  FinishGetUserProfile,
  FinishUpdateUserProfileForm,
  InitChangePassword,
  InitGetUserProfile,
  InitUpdateUserProfileForm,
  SetIsCollapsed,
} from './userProfile.actions';

export interface UserProfileState {
  loadingGetUserProfile: boolean;
  loadingUpdateUserProfileForm: boolean;
  profile: IUserProfileModel | null;
  loadingChangePassword: boolean;
  isCollapsed: boolean;
}

export const initialUserProfileState: UserProfileState = {
  loadingGetUserProfile: false,
  loadingUpdateUserProfileForm: false,
  profile: null,
  loadingChangePassword: false,
  isCollapsed: false,
};

export const userProfileReducer = createReducer(
  initialUserProfileState,
  on(InitGetUserProfile, (state) => {
    return {
      ...state,
      loadingGetUserProfile: true,
    };
  }),
  on(FinishGetUserProfile, (state, { profile }) => {
    return {
      ...state,
      loadingGetUserProfile: false,
      profile,
    };
  }),
  on(InitUpdateUserProfileForm, (state) => {
    return {
      ...state,
      loadingUpdateUserProfileForm: true,
    };
  }),
  on(FinishUpdateUserProfileForm, (state) => {
    return {
      ...state,
      loadingUpdateUserProfileForm: false,
    };
  }),

  on(InitChangePassword, (state) => {
    return {
      ...state,
      loadingChangePassword: true,
    };
  }),
  on(FinishChangePassword, (state) => {
    return {
      ...state,
      loadingChangePassword: false,
    };
  }),
  on(SetIsCollapsed, (state, { isCollapsed }) => {
    return {
      ...state,
      isCollapsed,
    };
  })
);
